import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';
import { fuseAnimations } from '@fuse/animations';
import { FuseNavigationItem, FuseVerticalNavigationMode } from '@fuse/components/navigation/navigation.types';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { FuseUtilsService } from '@fuse/services/utils/utils.service';
import * as _ from 'lodash';
import ls from 'localstorage-slim';
@Component({
    selector       : 'fuse-horizontal-navigation',
    templateUrl    : './horizontal.component.html',
    styleUrls      : ['./horizontal.component.scss'],
    animations     : fuseAnimations,
    encapsulation  : ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs       : 'fuseHorizontalNavigation'
})
export class FuseHorizontalNavigationComponent implements OnChanges, OnInit, OnDestroy
{
    @Input() name: string = this._fuseUtilsService.randomId();
    @Input() navigation: FuseNavigationItem[];

    onRefreshed: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    navigationCopy: FuseNavigationItem[];
    @Input() autoCollapse: boolean = true;
    @Input() inner: boolean = false;
    @Input() mn_type = '';
    loggedInUser: any;


    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _fuseNavigationService: FuseNavigationService,
        private _fuseUtilsService: FuseUtilsService
    )
    {
        this.loggedInUser =JSON.parse(ls.get('hms_loggedin_user'));
        console.log(this.loggedInUser);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On changes
     *
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void
    {
        // Navigation
        if ( 'navigation' in changes )
        {
            // Mark for check
            this._changeDetectorRef.markForCheck();
        }
    }

    /**
     * On init
     */
    ngOnInit(): void
    {

        if(this.mn_type == 'custom_menu')
            {
    
            }
            else{
                // if (this.navigation && this.navigation.length === 0) {
                    this.getAllMenuItems();
                // }
            }
        // Make sure the name input is not an empty string
        if ( this.name === '' )
        {
            this.name = this._fuseUtilsService.randomId();
        }

        // Register the navigation component
        this._fuseNavigationService.registerComponent(this.name, this);
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Deregister the navigation component from the registry
        this._fuseNavigationService.deregisterComponent(this.name);

        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Refresh the component to apply the changes
     */
    refresh(): void
    {
        // Mark for check
        this._changeDetectorRef.markForCheck();

        // Execute the observable
        this.onRefreshed.next(true);
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any
    {
        return item.id || index;
    }

    getAllMenuItems() {
        this._fuseNavigationService.getMenuItems().subscribe((res) => {
            let menuItems = res['data'];
            console.log(menuItems,"menuuuuuuuuuuuuuuuuuuuuuuuuuuu")
            this.navigation = menuItems;
            localStorage.setItem('menu_items',JSON.stringify(this.navigation))
            this.navigationCopy = [...this.navigation]
            for (let m = 0; m < menuItems.length; m++) {
                // menuItems[m].children = menuItems[m].children?.filter(function (obj) {
                // //   obj['link']=`internal${obj.link}`
                //     return obj.hdr_in !== 1;
                // });
                if(menuItems[m].children?.length === 0){
                    this.navigation.splice(m,1);
                    this.navigationCopy.splice(m,1);
                    
                }
            }
            menuItems.filter(val=>{
                val['mnu_itm_id']=val['prnt_mnu_itm_id']
                
            })
            // ChangeDetectorRef since file is loading outside the zone
            console.log(menuItems)
            this._changeDetectorRef.markForCheck();
            console.log(this.navigation)
            
        });
        
    }
    initializeItems = ()=>{
        this.navigation = _.cloneDeep(this.navigationCopy);
    }
    checkVal(val) {
        this.initializeItems();
        if (val) {
            this.navigation = this.navigation.filter((k) => {
                var fltr_chldrn = [];
                if (k['children'] && k['children'].length > 0) {
                    fltr_chldrn = k['children'].filter((c) => {
                        return   ((c['title'] + '').toLowerCase().indexOf(val.toLowerCase()) > -1);
                    });
                    if (fltr_chldrn && fltr_chldrn.length) {
                        return k['children'] = fltr_chldrn;
                    }
                }
                else {}
            })
        }
    }
}
